<mat-toolbar mat-dialog-title>
  <div>{{ title }}</div>
  <div style="flex-grow: 1"></div>
  <mat-icon class="cursor-pointer" mat-dialog-close>close</mat-icon>
</mat-toolbar>

<mat-dialog-content [class.no-outline]="!outline?.length">
  @if (outline?.length) {
    <div class="outline-pane">
      <ul>
        @for (item of outline; track item) {
          <li>
            <a (click)="navigateTo(item.dest)">{{ item.title }}</a>
            <ul>
              @for (child of item.items; track child) {
                <li>
                  <a (click)="navigateTo(child.dest)">{{ child.title }}</a>
                </li>
              }
            </ul>
          </li>
        }
      </ul>
    </div>
  }
  <div class="viewer-pane">
    <div class="controls">
      @if (pageCount) {
        <span class="page-count">{{ page }} / {{ pageCount }}</span>
      }
      <button type="button" mat-icon-button (click)="zoomOut()">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <button type="button" mat-icon-button (click)="zoomIn()">
        <mat-icon>zoom_in</mat-icon>
      </button>
      <button type="button" mat-icon-button (click)="rotateLeft()" title="Rotate left">
        <mat-icon>rotate_left</mat-icon>
      </button>
      <button type="button" mat-icon-button (click)="rotateRight()" title="Rotate right">
        <mat-icon>rotate_right</mat-icon>
      </button>
    </div>

    <pdf-viewer
      [src]="src"
      [zoom]="zoom"
      [rotation]="rotation"
      [zoom-scale]="'page-width'"
      [render-text]="false"
      [original-size]="false"
      [autoresize]="true"
      [show-borders]="true"
      (after-load-complete)="afterLoadComplete($event)"
      (pageChange)="page = $event"
    ></pdf-viewer>
  </div>
</mat-dialog-content>
